/**
 * Sperrt ALLE .nm-easywholesale-qty Felder für manuelle Eingabe.
 * ▸ Plus/Minus-Buttons funktionieren weiter (pack-steps.js).
 */

(() => {
  function isQtyField(el) {
    return el && el.classList.contains('nm-easywholesale-qty');
  }

  /* Tastatur & Paste blockieren */
  document.addEventListener('keydown', e => {
    if (isQtyField(e.target)) e.preventDefault();
  }, true);               // capture

  document.addEventListener('paste', e => {
    if (isQtyField(e.target)) e.preventDefault();
  }, true);

  /* Mausrad auf Zahlfeldern blockieren (Chrome scrollt sonst Werte) */
  document.addEventListener('wheel', e => {
    if (isQtyField(e.target)) e.preventDefault();
  }, { passive: false, capture: true });

  /* Vorsichtshalber: nach DOM-Load readonly setzen */
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.nm-easywholesale-qty')
      .forEach(inp => inp.setAttribute('readonly', 'readonly'));
  });
})();